import React from "react";

const TimeFormatter = ({ timestamp, lowercase = false }) => {
  const formatLastUpdated = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();

    const isToday = date.toDateString() === now.toDateString();
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    const diffTime = now - date;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // Convert ms to days

    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedTime = `${hours % 12 || 12}:${minutes} ${period}`;

    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayName = daysOfWeek[date.getDay()];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    if (isToday) {
      return `${lowercase ? "today" : "Today"}, ${formattedTime}`;
    } else if (isYesterday) {
      return `${lowercase ? "yesterday" : "Yesterday"}, ${formattedTime}`;
    } else if (diffDays < 7) {
      return `${dayName}, ${formattedTime}`; // Show only the day of the week for last 7 days
    } else {
      return now.getFullYear() === year
        ? `${day} ${month}, ${formattedTime}` // Show Month & Date for older entries
        : `${day} ${month}, ${year}, ${formattedTime}`;
    }
  };

  return <span>{formatLastUpdated(timestamp)}</span>;
};

export default TimeFormatter;
